import OpenInNewOutlined from "@mui/icons-material/OpenInNewOutlined";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useCallback } from "react";
import PropTypes from "prop-types";
import { useLoanFilesHook } from "../../../hooks/useLoanFilesHook";

const OpenLoanFileInNewTabButton = ({ loanId, fileObject }) => {
  const { loading, getFileById } = useLoanFilesHook();

  const handleDownload = useCallback(() => {
    if (!fileObject) return;

    getFileById({
      loanId,
      file_storage_name: fileObject.file_storage_name,
      fileDownloadName: fileObject.file_display_name,
      openInNewTab: true,
    });
  }, [fileObject, loanId, getFileById]);

  return (
    <Tooltip title="Open in new tab">
      <IconButton
        onClick={handleDownload}
        disabled={loading}
        color="primary"
        size="small"
      >
        <OpenInNewOutlined />
      </IconButton>
    </Tooltip>
  );
};

OpenLoanFileInNewTabButton.propTypes = {
  loanId: PropTypes.string,
  fileObject: PropTypes.object,
};

export default OpenLoanFileInNewTabButton;
